//引入平台级元数据
import '../metadata';
//语言包
import i18n from '../i18n';

!function (global) {
  dsf.mix(true, global.$i18n, { ...i18n });
}(dsf.global || (dsf.global = {}))
